import React from 'react';
import { useMatch } from 'react-router-dom';

import { useNotify } from 'hooks';
import {
  GetUserSearchesV2QueryVariables,
  SearchSortFieldsV2,
  SegmentStatus,
  useGetUserSearchesV2Query,
  useGetUserSegmentsQuery,
  UserStatus,
} from 'api';
import * as paths from 'paths';
import { Loaders } from 'components';

import { ContentEmails, ContentEmailsCreate, ContentEmailsEdit } from './index';

const ContentEmailsLoader = () => {
  const isCreate = !!useMatch(paths.adminContentEmailCreate);
  const isEdit = !!useMatch(paths.adminContentEmailEdit);
  const notify = useNotify();

  const userSearchesV2Variables: GetUserSearchesV2QueryVariables = {
    q: '',
    size: 1,
    sort: SearchSortFieldsV2.FullName,
    user_status: UserStatus.Active,
  };

  const { data, isLoading } = useGetUserSegmentsQuery(
    { segment_status: SegmentStatus.Active },
    {
      onError: notify.queryError,
    }
  );

  const segments = data?.getUserSegments;
  const userSearchesOptions = useGetUserSearchesV2Query(userSearchesV2Variables, {
    onError: notify.queryError,
  });

  const count = userSearchesOptions.data?.getUserSearchesV2?.total_count;
  const isUserSearchesLoading = userSearchesOptions.isLoading;

  function getPage() {
    if (isCreate) {
      return ContentEmailsCreate;
    }
    if (isEdit) {
      return ContentEmailsEdit;
    }
    return ContentEmails;
  }

  const EmailsComponent = getPage();

  if (isLoading || isUserSearchesLoading) {
    return <Loaders.Standard />;
  }

  return <EmailsComponent segments={segments} userCount={count} />;
};

export default ContentEmailsLoader;
